<template>
  <div>
    <img src="@/assets/tarjeta_beneficios_tallerCRM.jpg" style="width: 100%" />
    <p class="tituloTarjeta">TALLER CRM</p>

    <ul style="list-style-type: disc">
      <li>Neumáticos desde 58€ con montaje y equilibrado.</li>
      <li>Baterías desde 113€ con 3 años de garantía.</li>
      <li>Vehículo de sustitución GRATIS.</li>
      <li>Servicio de recogida y entrega GRATIS.</li>
      <li>
        Cambio de aceite y filtros más revisión de 30 puntos del vehículo desde
        119€.
      </li>
      <li>Revisión gratuita PRE-ITV.</li>
    </ul>

    <p class="container-flex">
      <a href="tel:+34 91 594 88 29">
        <button
          class="pure-button botonLlamar"
          title="Pulse el botón para llamar al Taller CRM"
        >
          Llamar
        </button>
      </a>

      <a href="http://www.crmondejar.com/" target="_blank" class="link">
        <button class="pure-button botonLlamar">Infórmate</button>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    email() {},
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-bottom: 3rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  border-radius: 0.5rem;
  text-align: center;
}

.link {
  color: $colorMMT;
  font-weight: 460;
  margin-right: 3rem;
}
</style>
